export enum ClipboardCopyFailReason {
  CLIPBOARD_UNAVAILABLE = 'clipboard_unavailable',
  WRITE_REJECTED = 'write_rejected',
}
